module.exports = __webpack_public_path__ + "static/media/ic_reject_all.cd55c4d7.svg";